import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from "react";
import MuiDrawer from '@mui/material/Drawer';
import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ButtonBase from '@mui/material/ButtonBase';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import { AreaChart, XAxis, YAxis, Tooltip, Area } from 'recharts';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, deleteDoc, collection, onSnapshot, orderBy, limit, query, where, addDoc, updateDoc } from 'firebase/firestore'
import { getStorage, ref, deleteObject, uploadBytes, getDownloadURL } from "firebase/storage";

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

// Main function of this page
export default function StandardVisualization() {
    const theme = useTheme()
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [connectors, setConnectors] = useState([])
    const [feed, setFeed] = useState("");
    const [specific, setSpecific] = useState("");
    const [data, setData] = useState("");

    /* Firestore SDK queries */
    useEffect(() => {
      const connectorQuery = query(
          collection(firestore, 'connectors'),
          where('user_email', '==', user_email)
      );
      const unsubscribe = onSnapshot(connectorQuery, snapshot => {
          setConnectors(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
      })

      return () => {
          unsubscribe()
      }
    }, [])

    useEffect(() => {
      const connectorQuery = query(
          collection(firestore, 'connectors'),
          where('user_email', '==', user_email),
          where('id', '==', Number(feed))
      );
      const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setSpecific(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
      })

      return () => {
          unsubscribe()
      }
    }, [feed])

    function handleConfirm() {
      if (feed == "") {
        alert("Please select a valid feed!")
        return 
      }

      const filename = specific[0].data.file
      getDownloadURL(ref(storage, user_email + '/' + filename))
      .then((url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
          handleFile(blob)
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
      });
    }

    function handleFile(file) {
      const reader = new FileReader()

      reader.onload = function (e) {
        const text = e.target.result;
        var Data = csvToArray(text);
        Data.pop()
        var tmp = []
        Data.forEach(element => {
          tmp.push(createData(element[Object.keys(element)[0]], element[Object.keys(element)[1]], element[Object.keys(element)[2]]))
        });
        setData(tmp)
      };
      reader.readAsText(file)
  }

  function csvToArray(str, delimiter = ",") {
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");
    const arr = rows.map(function (row) {
      const values = row.split(delimiter);
      const el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });

    return arr.slice(0, 20)
  }

  function createData(data1, data2, data3) {
    return {
      name: data1, 
      feature1: data2, 
      feature2: data3
    };
  }

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
              {/* Sub-Sidebar layout */}
              <Drawer variant="permanent" open={open} >
                  <Toolbar
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      px: [1],
                      height: 66,
                  }}
                  >
                  <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                      {open ? (
                      <KeyboardDoubleArrowLeftIcon />
                      ) : (
                      <KeyboardDoubleArrowRightIcon />
                      )}
                  </IconButton>
                  </Toolbar>

                  <Divider />

                  {/* Sub-bar Navigations */}
                  <List component="nav">
                  <ListItemButton href="/Dashboard/Visualization" >
                      <ListItemIcon>
                        <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Standard" />
                  </ListItemButton>

                  <ListItemButton  href="/Dashboard/Visualization/CustomVisualization/">
                      <ListItemIcon>
                          <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Custom" />
                  </ListItemButton>
                  </List>
              </Drawer>

            {/* Main space of page*/}
              <Box>
                <Box sx={{ width: "100%" }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                    >
                        Ambient / Data Visualization / Standard
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                    >
                        Standard
                    </Typography>
                </Box>

                <Box>
                  <Box sx={{ ml: 6, display: "flex" }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ mt: 3, ml: 2 }}
                        >
                        Please select one data feed of yours: 
                    </Typography>

                    <FormControl sx={{ ml: 1, mt: 2, minWidth: 200 }} variant= "standard">
                        <Select native defaultValue="" label="Feed" disableUnderline
                            theme={theme}
                            sx={{
                                borderRadius: 25,
                                backgroundColor: theme.palette.background.default,
                                padding: "6px 15px",
                            }}
                            value={feed}
                            onChange={(e) => {setFeed(e.target.value)}}>
                            
                            <option aria-label="None" value="">Your feed</option>
                            {connectors?.map((row) => (
                                <option value={row.data.id}>{row.data.name}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2, ml: 2, borderRadius: 5 }}
                        position="absolute"
                        onClick={handleConfirm}
                    >
                        Confirm
                    </Button>
                  </Box>

                  <Box sx={{ width: '100%', mt: 5 }}>
                    {data && 
                    <AreaChart width={1000} height={300} data={data}
                        margin={{ top: 10, right: 30, left: 50, bottom: 10 }}>
                        <defs>
                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                            </linearGradient>
                            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                            </linearGradient>
                        </defs>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Area type="monotone" dataKey="feature1" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                        <Area type="monotone" dataKey="feature2" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                    </AreaChart>
                    }
                  </Box>
                </Box>
              </Box>
        </Box>
    );
}